if (!customElements.get("price-range")) {
  customElements.define(
    "price-range",
    class PriceRange extends HTMLElement {
      connectedCallback() {
        this.rangeLowerBound = this.querySelector(".price-range__range-group .range-min");
        this.rangeLowerBubble = this.querySelector(".range-min-value span:first-child");
        this.rangeHigherBound = this.querySelector(".price-range__range-group .range-max");
        this.rangeHigherBubble = this.querySelector(".range-max-value span:first-child");
        this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
        this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
        this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
        this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

        this.textInputLowerBound.addEventListener("change", (event) => {
          event.target.value = Math.max(
            Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1),
            event.target.min
          );
          this.rangeLowerBound.value = event.target.value;
          this.rangeLowerBound.parentElement.parentElement.style.setProperty(
            "--range-min",
            `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`
          );
        });

        this.textInputHigherBound.addEventListener("change", (event) => {
          event.target.value = Math.min(
            Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1),
            event.target.max
          );
          this.rangeHigherBound.value = event.target.value;
          this.rangeHigherBound.parentElement.parentElement.style.setProperty(
            "--range-max",
            `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`
          );
        });

        this.rangeLowerBound.addEventListener("change", (event) => {
          this.textInputLowerBound.value = event.target.value;
          this.rangeLowerBubble.innerHTML = event.target.value;
        //   this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
        });

        this.rangeHigherBound.addEventListener("change", (event) => {
          this.textInputHigherBound.value = event.target.value;
          this.rangeHigherBubble.innerHTML = event.target.value;
        //   this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
        });

        this.rangeLowerBound.addEventListener("input", (event) => {
          event.target.value = Math.min(
            parseInt(event.target.value),
            parseInt(this.textInputHigherBound.value || event.target.max) - 1
          );
          event.target.parentElement.parentElement.style.setProperty(
            "--range-min",
            `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
          );
          this.textInputLowerBound.value = event.target.value;
          this.rangeLowerBubble.innerHTML = event.target.value;
        });

        this.rangeHigherBound.addEventListener("input", (event) => {
          event.target.value = Math.max(
            parseInt(event.target.value),
            parseInt(this.textInputLowerBound.value || event.target.min) + 1
          );
          event.target.parentElement.parentElement.style.setProperty(
            "--range-max",
            `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
          );
          this.textInputHigherBound.value = event.target.value;
          this.rangeHigherBubble.innerHTML = event.target.value;
        });
      }
    }
  );
}
